(function () {

  function initSection(sectionEl) {
    var sectionId    = sectionEl.dataset.tslId;
    var autoplay     = sectionEl.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(sectionEl.dataset.autoplaySpeed) || 5000;
    if (!sectionId) return;

    var track      = document.getElementById('tsl-track-' + sectionId);
    var dotsWrap   = document.getElementById('tsl-dots-' + sectionId);
    var arrowsWrap = document.getElementById('tsl-arrows-' + sectionId);
    if (!track) return;

    var current       = 0;
    var total         = track.querySelectorAll('.tsl-slide').length;
    var autoplayTimer;
    var isDragging    = false;
    var isMouseDown   = false;
    var startX        = 0;
    var currentX      = 0;
    var dragThreshold = 50;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.tsl-dot').forEach(function (d, i) {
          d.classList.toggle('active', i === current);
        });
      }

    }

    // Dot clicks
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.tsl-dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(this.getAttribute('data-index')));
          resetAutoplay();
        });
      });
    }

    // Arrow clicks
    if (arrowsWrap) {
      var prevBtn = arrowsWrap.querySelector('.tsl-arrow--prev');
      var nextBtn = arrowsWrap.querySelector('.tsl-arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetAutoplay(); });
    }

    // Touch swipe
    track.addEventListener('touchstart', function (e) {
      isDragging = true;
      startX = e.touches[0].clientX;
      currentX = startX;
      track.classList.add('dragging');
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('dragging');
      var diff = startX - currentX;
      if (Math.abs(diff) > dragThreshold) {
        goTo(current + (diff > 0 ? 1 : -1));
        resetAutoplay();
      }
    }, { passive: true });

    // Mouse drag
    track.addEventListener('mousedown', function (e) {
      isMouseDown = true;
      startX = e.clientX;
      currentX = startX;
      track.style.cursor = 'grabbing';
      track.classList.add('dragging');
    });

    document.addEventListener('mousemove', function (e) {
      if (!isMouseDown) return;
      currentX = e.clientX;
    });

    document.addEventListener('mouseup', function () {
      if (!isMouseDown) return;
      isMouseDown = false;
      track.style.cursor = 'grab';
      track.classList.remove('dragging');
      var diff = startX - currentX;
      if (Math.abs(diff) > dragThreshold) {
        goTo(current + (diff > 0 ? 1 : -1));
        resetAutoplay();
      }
    });

    track.style.cursor = 'grab';
    track.style.userSelect = 'none';

    // Autoplay
    function startAutoplay() {
      autoplayTimer = setInterval(function () { goTo(current + 1); }, autoplaySpeed);
    }

    function resetAutoplay() {
      clearInterval(autoplayTimer);
      if (autoplay) startAutoplay();
    }

    if (autoplay) startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.tsl-section[data-tsl-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.tsl-section[data-tsl-id]');
    if (s) initSection(s);
  });

})();
